import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axios';
import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { currentUser } = useAuth();
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentUser?.role) {
      // Куратор имеет все права сразу, без запроса к API
      if (currentUser.role === 'curator') {
        setPermissions('all');
        setLoading(false);
        return;
      }
      
      fetchPermissions();
    }
  }, [currentUser]);

  const fetchPermissions = async () => {
    try {
      const response = await axiosInstance.get(`/role-permissions/${currentUser.role}`);
      setPermissions(response.data.permissions);
    } catch (error) {
      console.error('Error fetching permissions:', error);
      setPermissions({});
    } finally {
      setLoading(false);
    }
  };

  const hasPermission = (resource, action) => {
    // Куратор имеет все права
    if (currentUser?.role === 'curator' || permissions === 'all') {
      return true;
    }

    if (!permissions) {
      return false;
    }

    return permissions[resource]?.[action] || false;
  };

  const hasAnyPermission = (checks) => {
    return checks.some(({ resource, action }) => hasPermission(resource, action));
  };

  const canView = (resource) => hasPermission(resource, 'view');
  const canCreate = (resource) => hasPermission(resource, 'create');
  const canEdit = (resource) => hasPermission(resource, 'edit');
  const canDelete = (resource) => hasPermission(resource, 'delete');

  return {
    permissions,
    loading,
    hasPermission,
    hasAnyPermission,
    canView,
    canCreate,
    canEdit,
    canDelete
  };
};
